import { TProgressRankingsClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

// Action Types
export const GET_PROGRESS_RANKINGS = 'GET_PROGRESS_RANKINGS';
export const SHOW_PROGRESS_RANKINGS_SPINNER = 'SHOW_PROGRESS_RANKINGS_SPINNER';

export type TGetProgressRankingsAction = TAction<TProgressRankingsClientState>;
export type TShowProgressRankingsSpinner = TAction<boolean>;

// Action Creators
export function createActionGetProgressRankings(
  progressRankings: TProgressRankingsClientState
): TGetProgressRankingsAction {
  return {
    type: GET_PROGRESS_RANKINGS,
    payload: progressRankings
  };
}

export function createActionShowLoadingSpinner(show: boolean): TShowProgressRankingsSpinner {
  return {
    type: SHOW_PROGRESS_RANKINGS_SPINNER,
    payload: show
  };
}
